import * as yup from 'yup';

import { useYupValidators } from '~/utils/yupValidators';

const useBankOTPSchema = () => {
  const yupValidators = useYupValidators();
  const bankOtpSchema = yup.object().shape({
    otp: yupValidators.otp,
  });

  return { bankOtpSchema };
};

export { useBankOTPSchema };
